import ListaArtigos from '../../componentes/ListaArtigos';   

const ListagemArtigos = () => {

    return(
        <div>
            <div className="container-fluid mt-3">
                <ListaArtigos />
            </div>
        </div>
    )
}

export default ListagemArtigos;